import { openActivityLogPopup } from 'modules/activity-log/activityLogPopupSlice'
import { ActivityReasonCategory } from 'types/activity'

interface ActivityLogCallback {
  reason: string
  reasonCategory: ActivityReasonCategory
  zendeskTicket: string
}

interface HandleActivityLogOptions {
  isImpersonated: boolean
  isTestUser: boolean
  isActivityLogEnabled: boolean
  dispatch: (action: any) => void
  contentText: string
  onSubmit: (data: ActivityLogCallback) => void
  isShowActivityPopup?: boolean
}

/**
 * Handles activity log popup display logic based on user impersonation and feature flags.
 * If conditions are met, shows an activity log popup; otherwise, executes the callback with default values.
 *
 * @param options - Configuration object containing impersonation status, feature flags, and callback handlers
 * @param options.isImpersonated - Whether the current user is impersonating another user
 * @param options.isTestUser - Whether the current user is a test user
 * @param options.isActivityLogEnabled - Whether the activity log feature is enabled
 * @param options.dispatch - Redux dispatch function
 * @param options.contentText - Text to display in the activity log popup
 * @param options.onSubmit - Callback function to execute with activity log data
 */
export const handleActivityLogPopup = ({
  isImpersonated,
  isTestUser,
  isActivityLogEnabled,
  dispatch,
  contentText,
  onSubmit,
  isShowActivityPopup = false,
  ...rest
}: HandleActivityLogOptions): void => {
  if (isImpersonated && !isTestUser && isActivityLogEnabled && isShowActivityPopup) {
    dispatch(
      openActivityLogPopup({
        required: true,
        contentText,
        onSubmit,
        ...rest,
      })
    )
  } else {
    onSubmit({
      reason: '',
      reasonCategory: ActivityReasonCategory.OTHER,
      zendeskTicket: '',
    })
  }
}
